<template>
    <div :class="'help ' + horizontal">
        <a-button @click="helpClicked" :disabled="loading"><img src="/img/Help.png" alt="Auggie Help"></a-button>
        <Teleport to="body">
            <help-modal ref="HelpModalRef" />
        </Teleport>
    </div>
</template>

// Help Icon : https://iconarchive.com/show/elementary-icons-by-danrabbit/Button-help-icon.html
// License: GNU GPL

<style scoped lang="scss">
    .help {
        position:fixed;
        bottom:0;
        a {
            font-size:.25em;
            padding: 1rem;
        }
        img {
            width: 64px;
            height: 64px;
        }
        &.left  {
            left:2rem;
            margin:1rem 0 2rem 0;
        }
        &.right-offset  {
            right:7rem;
            margin:1rem 0 2rem 0;
        }
        &.right  {
            right:2rem;
            margin:1rem 0 2rem 0;
        }
    }
    .help.inline {
        position:relative;
        bottom:initial;
        display:inline-block;
        line-height:0;
        img {
            width:3rem;
            height:3rem;
        }
    }
</style>

<script lang="ts">
import { defineComponent } from "vue";
import HelpModal from "@/views/HelpModal.vue";

export default defineComponent({
    name: "Help",
    components: {
        HelpModal
    },
    props: {
        horizontal: {
            type: String,
            default: "left"
        },
        loading: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        helpClicked(): void {
            if (this.loading) return;
            (this.$refs.HelpModalRef as InstanceType<typeof HelpModal>).show();
        }
    }
});

</script>
